export const ParallelTaskManager = {
    /**
     * Выполняет задачи параллельно.
     * Поведение похоже на Promise.all
     * @param {Array.<Object>} params.eachTaskParams
     * @param {Function} params.taskFactory – should return promise
     * @param {number} params.maxParallelTaskCount
     * @returns {Promise}
     */
    all({ eachTaskParams, taskFactory, maxParallelTaskCount }) {
        const _allTaskCount = eachTaskParams.length;
        const _tasksResults = new Array(_allTaskCount);
        let _activeTaskCount = 0;
        let _lastTaskIndex = 0;
        let _failed = false;
        let _firstReason;
        let _deferred;

        function _onTaskDone(taskResult, taskIndex) {
            _activeTaskCount--;
            _tasksResults[taskIndex] = taskResult;

            _execNextTaskIfNeededOrFinish();
        }

        function _onTaskFail(reason) {
            _activeTaskCount--;

            if (!_failed) {
                _failed = true;
                _firstReason = reason;
            }

            _execNextTaskIfNeededOrFinish();
        }

        function _execTask(taskParams, taskIndex) {
            taskFactory(taskParams).then((taskResult) => {
                _onTaskDone(taskResult, taskIndex);
            }, _onTaskFail);
        }

        function _execNextTaskIfNeeded() {
            if (
                _lastTaskIndex >= _allTaskCount ||
                _activeTaskCount >= maxParallelTaskCount
            ) {
                return;
            }
            _execTask(eachTaskParams[_lastTaskIndex], _lastTaskIndex);

            _lastTaskIndex++;
            _activeTaskCount++;

            _execNextTaskIfNeededOrFinish();
        }

        function _execNextTaskIfNeededOrFinish() {
            if (_activeTaskCount) {
                if (!_failed) {
                    _execNextTaskIfNeeded();
                }
            } else if (!_lastTaskIndex) {
                _execNextTaskIfNeeded();
            } else if (_failed) {
                _deferred.reject(_firstReason);
            } else {
                _deferred.resolve(_tasksResults);
            }
        }

        return new Promise((resolve, reject) => {
            _deferred = { resolve, reject };

            _execNextTaskIfNeededOrFinish();
        });
    },
};
